import {
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { Tags } from '.';

const GET_TAGS = process.env.REACT_APP_GET_TAGS_QUERY;
const ADD_TAG_POPULARITY = process.env.REACT_APP_ADD_TAG_POPULARITY_QUERY;

// const APP_PATHNAME = process.env.REACT_APP_PATHNAME;

// const resource = APP_PATHNAME?.split('//')[1] || 'nevatrip.ru';
const baseUrl = '/api';

export const apiSlice = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: builder => ({
    getTags: builder.query<Tags, void>({
      query: () => GET_TAGS as string,
    }),
    addTagPopularity: builder.mutation<any, { session: string; tag: string }>({
      query: data => {
        const body = new URLSearchParams();
        body.append('session', data.session);
        body.append('tag', data.tag);

        return { url: ADD_TAG_POPULARITY, method: 'POST', body } as FetchArgs;
      },
    }),
  }),
});

export const { useGetTagsQuery, useAddTagPopularityMutation } = apiSlice;

export const { useQueryState: useGetTagsQueryState } =
  apiSlice.endpoints.getTags;
